import { useState } from 'react';
import { Header, useIsReloading } from '@/components/DashboardComponents'
import { useRevalidator } from 'react-router'
import { Button, Textbox, Spacing, Dropdown, DropdownOption } from '@/form/FormComponents'
import { FormProvider, FormSubmitProvider } from '@/form/FormProvider';
import { Modal, ModalContent, ModalButtons, useErrorModal, useModal } from '@/components/Modal';
import { Icon } from '@/components/Icon';
import { internalAction } from '@/data/loaders';

export function SendEmails({}) {
  const [submitting, setIsSubmitting] = useState(false);
  const is_reloading = useIsReloading();
  const [openErrorModal] = useErrorModal();

  const [openSubmittedModal] = useModal(({ context, closeModal }) => {
    return (
      <Modal width={330}>
        <ModalContent>
          <div className="assignment_submitted">
            <Icon name="check-circle"/>
            <div>{"Emails sent"}</div>
          </div>
        </ModalContent>
        <ModalButtons centered={true}>
          <Button text="Close" onClick={closeModal} /> 
        </ModalButtons>
      </Modal>
    )
  });

  function submitForm({ formatted_data }) {
    setIsSubmitting(true);

    internalAction("sendEmails", {
      ...formatted_data
    }).then(function() {
      setIsSubmitting(false);
      openSubmittedModal();
    }).catch(function(error) {
      setIsSubmitting(false);
      openErrorModal();
    })
  }

  return (
    <FormProvider onSubmit={submitForm} unsaved_modal="send_emails">
      <Header title="Send email tool"/>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <div className="dashboard_content_container">
          <Dropdown name="list" title="List" required={true} default_value="test">
            <DropdownOption name="test" text="Test message"/>
            <DropdownOption name="product_announcements_educators" text="Product updates (educators only)"/>
          </Dropdown>
          <Spacing/>
          <Textbox name="sender_email" title="Sender email" required={true} default_value="updates@sapientclinician.com"/>
          <Spacing/>
          <Textbox name="sender_name" title="Sender name" required={true} default_value="Sapient Clinician"/>
          <Spacing/>
          <Textbox name="subject" title="Subject" required={true}/>
          <Spacing/>
          <Textbox name="html" title="Body (HTML)" required={true} multiline={true}/>
          <Spacing/>
          <div className="buttons">
            <FormSubmitProvider>
              {({handleSubmit, has_changed}) => {
                return <Button className="primary wide" text="Send" onClick={handleSubmit} disabled={submitting || !has_changed || is_reloading} loading={submitting}/>
              }}
            </FormSubmitProvider>
          </div>
        </div>
      </div>
    </FormProvider>
  )
}